module.exports = __webpack_public_path__ + "static/media/DanskeNarrow-Italic.3bed4b92.ttf";